import { site } from '../content/site';
import './Hero.css';

export default function Hero() {
  const { hero, name, role } = site;
  return (
    <section className="hero" aria-labelledby="hero-heading">
      <div className="container hero__inner">
        <span className="eyebrow">{hero.eyebrow}</span>
        <h1 id="hero-heading" className="hero__heading display">
          {hero.headline}
        </h1>
        <p className="hero__intro">{hero.intro}</p>
        <div className="hero__meta">
          <span className="hero__name">{name}</span>
          <span aria-hidden="true">·</span>
          <span>{role}</span>
        </div>
        <div className="hero__ctas">
          <a className="btn btn--primary" href={hero.primaryCta.href}>
            {hero.primaryCta.label}
          </a>
          <a className="btn btn--ghost" href={hero.secondaryCta.href}>
            {hero.secondaryCta.label}
          </a>
        </div>
      </div>
    </section>
  );
}
